import React from "react";

export const SvgIconBase = (props) => {
  const { width, height, viewBox = "0 0 65 65", path, fill = "white", style = {} } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      style={style}
    >
      <path
        fill={fill}
        d={path}
      />
    </svg>
  );
};
